<script setup>
import { storeToRefs } from 'pinia'
import { useSideBarStore } from '~/stores/sideBar'

// Global
const sideBarStore = useSideBarStore()
const { isSideBarLayerOpen } = storeToRefs(sideBarStore)
</script>

<template>
    <Transition name="fade">
        <UserAccountOnBoardingForm v-if="isSideBarLayerOpen" />
    </Transition>
</template>
